import { useEffect } from "react";
import Booking from "./pages/booking";
import { SERVICES_RESCHEDULE, USER_INFO, X_Tenant_Id } from "common/constant";

function App() {
  useEffect(() => {
    // Function to extract the ID from the URL
    const extractIdFromUrl = () => {
      const pathname = window.location.pathname;
      // Assuming the ID is the last segment of the URL after the last '/'
      const id = pathname.substring(pathname.lastIndexOf("/") + 1);
      return id;
    };

    // Processing data from client app
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const phone = params.get("phone");
    const services = params.get("services");

    if (phone || services) {
      if (phone) {
        sessionStorage.setItem(USER_INFO, phone);
        params.delete("phone");
      }

      if (services) {
        const servicesDecoded = decodeURIComponent(services);
        sessionStorage.setItem(SERVICES_RESCHEDULE, servicesDecoded);
        params.delete("services");
      }

      const newUrl = window.location.pathname;
      window.history.replaceState(null, "", newUrl);
    }

    // Extract the ID and set it in sessionStorage
    const id = extractIdFromUrl();
    if (id) {
      sessionStorage.setItem(X_Tenant_Id, id);
    } else if (sessionStorage.getItem(X_Tenant_Id) === null) {
      window.location.replace("https://richpaymentsolutions.com/");
    }
  }, []);

  return <Booking />;
}

export default App;
